export default "__VITE_ASSET__Dvb2DhUk__"